// init LazyLoad
FN.lazyLoad = () => {
    let lazyLoadInstance = new LazyLoad({

    })
}